__turbopack_context__.v({
  "landscapeContainer": "MoreInformation-module__CJIWmq__landscapeContainer",
  "landscapeHeader": "MoreInformation-module__CJIWmq__landscapeHeader",
  "landscapeLink": "MoreInformation-module__CJIWmq__landscapeLink",
  "landscapeMain": "MoreInformation-module__CJIWmq__landscapeMain",
  "portraitContainer": "MoreInformation-module__CJIWmq__portraitContainer",
});
